var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { BackInStockConfiguration } from '../../helpers/BackInStockConfiguration';
import { default as bemCssModules } from 'bem-css-modules';
import { default as NotifyCumulusStyle } from './NotifyCumulus.module.css';
import { NotifyForm } from './NotifyForm/NotifyForm';
import { NotifyType } from './NotifyType/NotifyType';
import { NotifyTypeEnum } from './helpers/NotifyTypeEnum';
import { PopupHeader } from '../PopupHeader/PopupHeader';
import { request } from './helpers/axios';
import { Thanks } from './Thanks/Thanks';
import { useTranslationByKey } from '../../helpers/useTranslationByKeys';
import React, { useCallback, useEffect, useState } from 'react';
const style = bemCssModules(NotifyCumulusStyle);
const defaultData = {
    email: null,
    telephoneNumber: null,
};
export const NotifyCumulus = ({ productCode, }) => {
    const { isEditionEnabled } = BackInStockConfiguration.getConfig();
    const t = useTranslationByKey();
    const [currentType, changeType] = useState(NotifyTypeEnum.email);
    const [inputData, changeInputData] = useState('');
    const [isReserved, changeReservationState] = useState(false);
    const [userDataFromAPI, setUserData] = useState(defaultData);
    const fetchData = () => __awaiter(void 0, void 0, void 0, function* () {
        const { data } = yield request.get('system/ajax/stockNotification/userData');
        setUserData(data);
        if (data.email && currentType === NotifyTypeEnum.email) {
            changeInputData(data.email);
        }
        else if (data.telephoneNumber && currentType === NotifyTypeEnum.sms) {
            changeInputData(data.telephoneNumber);
        }
    });
    useEffect(() => {
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        fetchData();
    }, 
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
    const handleOnChangeData = useCallback((event) => {
        if (!isEditionEnabled) {
            return;
        }
        const trimmedValue = event.currentTarget.value.trim();
        changeInputData(trimmedValue);
    }, [isEditionEnabled]);
    const handleOnChangeType = useCallback((event) => {
        const { value } = event.currentTarget;
        changeType(value);
        if (userDataFromAPI.email && value === NotifyTypeEnum.email) {
            changeInputData(userDataFromAPI.email);
        }
        else if (userDataFromAPI.telephoneNumber &&
            value === NotifyTypeEnum.sms) {
            changeInputData(userDataFromAPI.telephoneNumber);
        }
    }, [userDataFromAPI.email, userDataFromAPI.telephoneNumber]);
    const handleOnSubmit = useCallback(() => {
        changeReservationState(true);
    }, []);
    return (React.createElement("div", { className: style() }, isReserved ? (React.createElement(Thanks, { contactToUser: inputData })) : (React.createElement(React.Fragment, null,
        React.createElement(PopupHeader, { title: t('Notify me when the product becomes available') }),
        React.createElement(NotifyType, { currentType: currentType, handleOnChange: handleOnChangeType }),
        React.createElement(NotifyForm, { currentType: currentType, handleOnChange: handleOnChangeData, handleOnSubmit: handleOnSubmit, inputData: inputData, productCode: productCode })))));
};
